import {
    FETCH_BI,
    IS_BI_LOADING,
    IS_BI_REFETCHING,
    BI_COMPARISON_LOADING,
    BI_COMPARISON_DATA,
    BI_COMPARISON_ERROR
} from "../actions/types";

const initialState = {
    loading: false,
    isRefetching: false,
    businessIntelligenceData: {
        success: true,
        data: {
            revenue: null,
            averageRate: null,
            loadCount: null,
            overview: [],
            loads: []
        }
    },
    comparisonData: {
        loading: false,
        data: {
            revenue: null,
            averageRate: null,
            loadCount: null,
            overview: [],
            loads: []
        },
        error: null
    }
}

const businessIntelligence = (state = initialState, {type, payload}) => {
    switch (type) {
        case FETCH_BI:
            return {
                ...state,
                businessIntelligenceData: {
                    ...payload,
                    data: {
                        ...payload.data,
                        overview: payload.data.loads || []
                    }
                }
            }
        case IS_BI_LOADING:
            return {
                ...state,
                loading: payload
            }
        case IS_BI_REFETCHING:
            return {
                ...state,
                isRefetching: payload
            }
        case BI_COMPARISON_LOADING:
            return {
                ...state,
                comparisonData: {
                    ...state.comparisonData,
                    loading: payload
                }
            }
        case BI_COMPARISON_DATA:
            return {
                ...state,
                comparisonData: {
                    ...state.comparisonData,
                    data: {
                        ...payload.data,
                        overview: payload.data.loads || []
                    },
                    error: null
                }
            }
        case BI_COMPARISON_ERROR:
            return {
                ...state,
                comparisonData: {
                    ...state.comparisonData,
                    error: payload
                }
            }
        default:
            return state
    }
}

export default businessIntelligence;